import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageMetadata, SITE_URL } from "../lib/seo";

export const RouteMetadata = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = pageMetadata(pathname);
    document.title = meta.title;
    const set = (attribute, key, content) => {
      let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!element) { element = document.createElement("meta"); element.setAttribute(attribute, key); document.head.appendChild(element); }
      element.setAttribute("content", content);
    };
    set("name", "description", meta.description);
    for (const [key, value] of Object.entries({ title: meta.title, description: meta.description, image: meta.image, url: meta.canonical })) set("property", `og:${key}`, value);
    set("property", "og:image:alt", meta.imageAlt);
    set("name", "twitter:image:alt", meta.imageAlt);
    for (const key of ["title", "description", "image"]) set("name", `twitter:${key}`, meta[key]);
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", meta.canonical);
    let schema = document.getElementById("route-schema");
    if (!schema) { schema = document.createElement("script"); schema.id = "route-schema"; schema.type = "application/ld+json"; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify({ "@context": "https://schema.org", "@type": "WebPage", name: meta.title, description: meta.description, url: meta.canonical, isPartOf: { "@id": `${SITE_URL}/#website` } });
  }, [pathname]);
  return null;
};